"use strict";

var _classCallCheck = require("/tmp/39540460/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/tmp/39540460/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/39540460/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/tmp/39540460/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/tmp/39540460/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/tmp/39540460/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @ignore
 * @module RPC-Error
 *
 * copyright defined in eosjs/LICENSE.txt
 */

var RpcError =
/*#__PURE__*/
function (_Error) {
  _inherits(RpcError, _Error);

  function RpcError(json) {
    var _this;

    _classCallCheck(this, RpcError);

    if (json.error && json.error.details && json.error.details.length && json.error.details[0].message) {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(RpcError).call(this, json.error.details[0].message));
    } else if (json.processed && json.processed.except && json.processed.except.message) {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(RpcError).call(this, json.processed.except.message));
    } else {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(RpcError).call(this, json.message));
    }

    Object.setPrototypeOf(_assertThisInitialized(_this), RpcError.prototype);
    _this.json = json;
    return _possibleConstructorReturn(_this);
  }

  return RpcError;
}(_wrapNativeSuper(Error));

exports.RpcError = RpcError;
/**
 * @ignore
 */

var RpcStatusError =
/*#__PURE__*/
function (_Error2) {
  _inherits(RpcStatusError, _Error2);

  function RpcStatusError(response) {
    var _this2;

    _classCallCheck(this, RpcStatusError);

    if (response.status === 405) {
      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(RpcStatusError).call(this, response.statusText));
    }

    Object.setPrototypeOf(_assertThisInitialized(_this2), RpcStatusError.prototype);
    _this2.response = response;
    return _possibleConstructorReturn(_this2);
  }

  return RpcStatusError;
}(_wrapNativeSuper(Error));

exports.RpcStatusError = RpcStatusError;